import { Box, Skeleton, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Root = styled(Box)(({ theme }) => ({
  flex: 1,
  minHeight: 0,
  display: "flex",
  alignItems: "stretch",
  gap: theme.spacing(0.5),
}));

export const Plot = styled(Box)({
  position: "relative",
  flex: 1,
  minWidth: 0,
});

export const Svg = styled("svg")({
  display: "block",
  width: "100%",
  height: "100%",
});

export const Gridline = styled("line")(({ theme }) => ({
  stroke: theme.palette.divider,
  strokeWidth: 1,
  strokeDasharray: "3 3",
  vectorEffect: "non-scaling-stroke",
}));

export const Line = styled("path", {
  shouldForwardProp: (prop) => prop !== "$consensus" && prop !== "$faded",
})<{ $consensus: boolean; $faded: boolean }>(({ $consensus, $faded }) => ({
  fill: "none",
  strokeWidth: $consensus ? 2 : 1.5,
  strokeLinejoin: "round",
  strokeLinecap: "round",
  opacity: $faded ? 0.35 : 1,
  vectorEffect: "non-scaling-stroke",
}));

export const Axis = styled(Box)({
  position: "relative",
  width: 40,
  flexShrink: 0,
});

export const AxisLabel = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "$value",
})<{ $value: boolean }>(({ $value, theme }) => ({
  position: "absolute",
  right: 0,
  transform: "translateY(-50%)",
  fontSize: $value ? 11 : 10,
  fontWeight: $value ? 700 : 400,
  lineHeight: 1,
  color: theme.palette.text.disabled,
  whiteSpace: "nowrap",
}));

export const Empty = styled(Typography)(({ theme }) => ({
  flex: 1,
  minHeight: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: 12,
  color: theme.palette.text.disabled,
}));

export const Placeholder = styled(Skeleton)(({ theme }) => ({
  position: "absolute",
  inset: 0,
  transform: "none",
  borderRadius: theme.shape.borderRadius,
}));
